import React, {useEffect, useState} from 'react';
import FormBuilder from "../FormBuilder/FormBuilder";
import AccountSides from "./AccountSides";
import _axios from "../../../httpService";
import {toast} from "react-toastify";
import Swal from 'sweetalert2';

// CommonJS

const Index = () => {

    // const Swal = require('sweetalert2')

    const [formData, setFormData] = useState(null)
    const [newAccountSideData, setNewAccountSideData] = useState([])
    const [disable, setDisable] = useState(true);

    useEffect(() => {
        if (formData !== null && newAccountSideData !== null) {
            setDisable(false)
        }
    }, [formData, newAccountSideData])

    function onSubmitFormHandler(input) {
        setFormData(input);
    }

    function onSubmitAccountSides(input) {
        console.log("newAccountSideData");
        console.log(newAccountSideData);
        console.log("input")
        console.log(input)
        debugger
        setNewAccountSideData(input);


    }

    function onFinalSubmit() {
        Swal.fire({
                icon: 'warning',
                title: "لطفا صبر کنید...",
                showDenyButton: false,
                showCancelButton: false,
                showConfirmButton: false,
            }
        );

        //get data

        let entityData = formData.filter(v => v.entityData)[0].entityData
        let fieldData = formData.filter(v => v.fieldData)[0].fieldData
debugger
        let bed = newAccountSideData.filter(v => v.bed)[0]
        console.log(bed);

        if (!bed) {
            toast.error("جدول بدهکار خالی است.")
            return
        }
        if (bed.bed.length === 0) {
            toast.error("جدول بدهکار خالی است.")
            return
        }

        bed = bed.bed

        let bes = newAccountSideData.filter(v => v.bes)[0];

        if (!bes) {
            toast.error("جدول بدهکار خالی است.")
            return
        }
        if (bes.bes.length === 0) {
            toast.error("جدول بدهکار خالی است.")
            return
        }
        bes = bes.bes


        let readyToSend = {entityData, fieldData, bed, bes};
        console.log(readyToSend)


        //send data to backEnd
        // این همه چیش آماده س  فقط  مهندس طاهری یه تیکه رو اوکی کنه میگیره اطلاعات رو


        _axios.post(`${localStorage.getItem("apiUrl2")}x/dm/`, readyToSend).then(res => {


            res = res.data;
            if (res.status === true) {
                Swal.fire({
                        icon: 'success',
                        title: res.message,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: 'باشه',
                    }
                );

                setFormData(null)
                setNewAccountSideData([])
                setDisable(true)
                return

            } else if (res.status === false) {
                Swal.close();
                toast.error(res.message);
                return
            }


            debugger;
            console.log(res);


        });

    }


    return (
        <>
            <div className={"my-4 px-2"}>
                {!formData &&
                    <FormBuilder
                        onSubmit={onSubmitFormHandler}
                        submitText={"ثبت و نمایش صورتحساب ها"}
                        comeFrom={"documentSaz"}
                    />}
                {formData &&
                    <AccountSides
                        onSubmitAccountSides={onSubmitAccountSides}
                        newFormData={formData.filter(v => v.fieldData)[0].fieldData}
                    />}


                <div className={"text-center mt-4"}>
                    <button
                        className={"btn btn-info "}
                        disabled={disable}
                        title={"تایید نهایی و ثبت فرم"}
                        onClick={onFinalSubmit}
                    >

                        تایید نهایی
                    </button>
                </div>

            </div>
        </>
    );
};

export default Index;